import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Fr, if someone, me or someone has time to fix the mess with any, go on
export const flattenDictionary = (data: any[] | undefined | null | Record<any, any>) => {
  return data?.reduce((r: any, { id, name }: { id: any; name: any }) => ((r[id] = name), r), {}) ?? {};
};

interface InputObject {
  [key: string]: any;
}
export const customFlattenDictionary = (
  arr: InputObject[] | null | undefined,
  keyId: string,
  keyDesc: string
): { [key: number]: string } => {
  const result: { [key: number]: string } = {};
  arr?.forEach((item) => {
    if (typeof item[keyId] === 'number' && typeof item[keyDesc] === 'string') {
      result[item[keyId]] = item[keyDesc];
    }
  });
  return result;
};

const convertValuesToStrings = (obj: unknown): unknown => {
  if (typeof obj !== 'object' || obj === null) {
    return String(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(convertValuesToStrings);
  }

  return Object.entries(obj).reduce<Record<string, unknown>>((acc, [key, value]) => {
    acc[key] = convertValuesToStrings(value);
    return acc;
  }, {});
};

export const convertJsonValuesToStrings = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;

  const parsed = JSON.parse(value);
  const converted = convertValuesToStrings(parsed);
  return JSON.stringify(converted, null, 2);
};
